export enum INGREDIENT_OPTIONS {
  RECIPE = 'RECIPE',
  PRODUCT = 'PRODUCT',
  NON_USFOODS_PRODUCT = 'NON_USFOODS_PRODUCT',
}

export enum VIEW_ALL_TYPES {
  ICON_AND_TEXT,
  ICON_ONLY_OUTLINE,
  ICON_ONLY_FILLED,
  TEXT_ONLY,
  NONE,
}
